export default __webpack_public_path__ + "static/media/wait.4c18c6fa.webp";